import React, { useCallback } from 'react'
import { useWallet } from 'use-wallet'
import styled from 'styled-components'

import Button from 'components/Button'
import Label from 'components/Label'
import Modal from 'components/Modal'
import ModalActions from 'components/ModalActions'
import ModalContent from 'components/ModalContent'
import ModalTitle from 'components/ModalTitle'
import Spacer from 'components/Spacer'
import Value from 'components/Value'

import useTokenBalance from 'hooks/useTokenBalance'
import { ubetToEth, getTokenURL } from 'lottery/constants'

const AccountModal = ({ onDismiss, history }) => {
  const { account, reset } = useWallet()
  const handleSignOutClick = useCallback(() => {
    onDismiss()
    reset()
  }, [onDismiss, reset])

  const handleGoMyPools = () => {
    history.push('/mypools')
    onDismiss()
  }

  const handleGoMyWinning = () => {
    history.push('/mywinnings')
    onDismiss()
  }

  const handleGoMyTicket = () => {
    history.push('/mytickets')
    onDismiss()
  }

  const balance = useTokenBalance()

  return (
    <Modal>
      <ModalTitle text="My Account" />
      <ModalContent>
        <Spacer />

        <div style={{ display: 'flex' }}>
          <StyledBalanceWrapper>
            <StyledBalance>
              <Value value={ubetToEth(balance)} />
              <Label text="UBET Balance" />
            </StyledBalance>
          </StyledBalanceWrapper>
        </div>

        <Spacer />
        <StyledGetTokenButton>
          <Button
            href={getTokenURL}
            text="Get more Token"
            variant="primary"
          />
        </StyledGetTokenButton>
        <Spacer />
        <Button
          href={`https://etherscan.io/address/${account}`}
          text="View on Etherscan"
          variant="secondary"
        />
        <Spacer />
        <Button
          onClick={handleGoMyPools}
          text="Pools I own"
          variant="secondary"
        />
        <Spacer />
        <Button
          onClick={handleGoMyWinning}
          text="My winnings"
          variant="secondary"
        />
        <Spacer />
        <Button
          onClick={handleGoMyTicket}
          text="My Tickets"
          variant="secondary"
        />
        <Spacer />
        <Button
          onClick={handleSignOutClick}
          text="Sign out"
          variant="secondary"
        />
      </ModalContent>
      <ModalActions>
        <Button onClick={onDismiss} text="Cancel" />
      </ModalActions>
    </Modal>
  )
}

const StyledBalance = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`

const StyledGetTokenButton = styled.button`
  width: 100%;
  border-color: #f44336;
`

const StyledBalanceWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing[4]}px;
`

export default AccountModal
